import Button from '@space-core/components/button'
import styled from 'styled-components'

export type ErrorFindMembershipProps = {
  title: string
  illustration: string
  textButton?: string
  onClick?: () => void
}

const Title = styled.h5`
  width: 25.25rem;
`

const ErrorFindMembership = ({
  title,
  illustration,
  textButton,
  onClick
}: ErrorFindMembershipProps) => {
  return (
    <div
      data-test='error-search-container'
      className='_d-flex _flex-column _align-items-center _justify-content-center _text-center _mt-12 _mb-0 _overflow-hidden'>
      <img alt={title} src={illustration} data-test='error-search-img' />
      <Title data-test='error-search-title' className='_font-weight-light _text-gray-700'>
        {title}
      </Title>

      <Button data-test='error-search-button' size='sm' onClick={onClick} aria-label='button'>
        {textButton}
      </Button>
    </div>
  )
}

export default ErrorFindMembership
